export const SET_VERSION_DATA = "SET_VERSION_DATA";

export const setVersionData = (payload) => (dispatch) => {
  return dispatch({ type: SET_VERSION_DATA, payload });
};
